import { NgModule } from "@angular/core";
import { JwtHelperService, JWT_OPTIONS } from "@auth0/angular-jwt";
import { TranslateModule } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import { LoaderComponent } from './components/loader/loader.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { DialogModule } from "primeng/dialog";
import { NotificationFeedComponent } from "../notification-feed/notification-feed.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChatPopupComponent } from "./components/chat-popup/chat-popup.component";
import { ReactiveFormsModule } from "@angular/forms";
import { MobileInputComponent } from "./components/mobile-input/mobile-input.component";
import { RequiredFieldDirective } from "./helpers/required-field.directive";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { SharedOTPDialogComponent } from "./components/shared-otp-dialog/shared-otp-dialog.component";
import { AutoTabDirective } from "./helpers/auto-tab.directive";
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from "@angular/common";
import { FileUploadComponent } from "./components/file-upload/file-upload.component";
import { FormsModule } from "@angular/forms";
import { DataTableComponent } from "./components/data-table/data-table.component";
import { StatusBadgeComponent } from "./components/status-badge/status-badge.component";
import { MultiSelectFilterComponent } from "./components/data-table/multi-select-filter/multi-select-filter.component";
import { ColumnFilterDropdownComponent } from "./components/data-table/column-filter-dropdown/column-filter-dropdown.component";
import { TableModule } from "primeng/table";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ConfirmationDialogComponent } from "./components/confirmation-dialog/confirmation-dialog.component";
import { MessageDialogComponent } from "./components/message-dialog/message-dialog.component";
import { ReasonInputDialogComponent } from "./components/reason-input-dialog/reason-input-dialog.component";
import { SearchableSelectComponent } from "./components/searchable-select/searchable-select.component";
import { EvaluationCriteriaComponent } from "./components/evaluation-criteria/evaluation-criteria.component";




@NgModule({
    imports: [
      CommonModule,
      DialogModule,
      TranslateModule,
      MatTooltipModule,
      ReactiveFormsModule,
      FormsModule,
      MatDialogModule,
      MatIconModule,
      MatButtonModule,
      MatFormFieldModule,
      MatInputModule,
      TableModule,
    ], 
   
    exports: [
      LoaderComponent,
      DialogComponent,
      NotificationFeedComponent,
      ChatPopupComponent,
      MobileInputComponent,
      RequiredFieldDirective,
      SharedOTPDialogComponent,
      FileUploadComponent,
      ToastrModule,
      AutoTabDirective,
      DataTableComponent,
      StatusBadgeComponent,
      MultiSelectFilterComponent,
      ColumnFilterDropdownComponent,
      SearchableSelectComponent,
      EvaluationCriteriaComponent,
      ReactiveFormsModule,
      FormsModule,
      MatDialogModule,
      MatIconModule,
      MatButtonModule,
      MatFormFieldModule,
      MatInputModule,
      CommonModule,

    ],
    declarations: [
    LoaderComponent,
    DialogComponent,
    NotificationFeedComponent,
    ChatPopupComponent,
    MobileInputComponent,
    RequiredFieldDirective,
    SharedOTPDialogComponent,
    FileUploadComponent,
    AutoTabDirective,
    DataTableComponent,
    StatusBadgeComponent,
    MultiSelectFilterComponent,
    ColumnFilterDropdownComponent,
      ConfirmationDialogComponent,
      MessageDialogComponent,
      ReasonInputDialogComponent,
      SearchableSelectComponent,
      EvaluationCriteriaComponent,
    
    
  ],
  providers: [
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS }, JwtHelperService,
    MessageService,
  ]
})
export class SharedModule {}